import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-tarjetadash',
  templateUrl: './tarjetadash.component.html',
  styleUrls: ['./tarjetadash.component.css']
})
export class TarjetadashComponent implements OnInit {
  @Input() valor:any;
  @Input() titulo:string;
  
  constructor() { }

  ngOnInit(): void {
  }

}
